export default {
  // Navbar
  'nav.home': '首页',
  'nav.custom': '私人订制',
  'nav.enterprise': '企业团建',
  'nav.about': '关于我们',
  'nav.wiki': '旷野百科',
  'nav.africa': '非洲旅行',
  'nav.polar': '南北极旅行',
  'nav.contact': '联系我们',
  'nav.customizeNow': '立即定制',
  'nav.phoneSicily': 'EVAN：19180619944',
  'nav.polarFinder': '极地航次查询',

  // Hero
  'hero.noSlides': '暂无轮播图数据',
  'hero.coreDestinations': '核心目的地',
  'hero.dest.polar': '南北极',
  'hero.dest.tanzania': '坦桑尼亚',
  'hero.dest.botswana': '博茨瓦纳',
  'hero.dest.kenya': '肯尼亚',
  'hero.dest.rwanda': '卢旺达',
  'hero.dest.namibia': '纳米比亚',
  'hero.dest.nordic': '北欧秘境',
  'hero.dest.island': '野奢海岛',
  'hero.stat.customers': '服务客户',
  'hero.stat.reviewRate': '好评率',
  'hero.stat.years': '目的地经验',
  'hero.stat.yearsNum': '13年',
  'hero.stat.ranking': '品牌创立',
  'hero.stat.guarantee': '正规资质保障',
  'hero.scroll': 'scroll',
  'hero.scrollDown': '向下滑动',
  'hero.tagline': '非洲Safari与南北极野奢定制旅行',

  // About
  'about.tag': '关于自由旷野旅行',
  'about.heading': '一入旷野，万物自由！',
  'about.p1': '自由旷野旅行（Free Wilderness Travel，简称 Free Wilderness）成立于2022年，由成都自由旷野国际旅行社有限公司运营，专注非洲 Safari、南北极及自然类野奢定制旅行。创始人及核心团队拥有13年非洲与极地目的地经验，官方网站为 freewds.com。团队长期深入非洲及极地目的地实地考察，累计服务客户10,000+，客户好评率98%。',
  'about.p2a': '公司创始团队均有多年出境高端奢华旅行从业经验。业务覆盖非洲游猎、极地探索、野奢海岛、奢华邮轮、北欧秘境及私人定制。',
  'about.p2b': '从博茨瓦纳奥卡万戈三角洲到南极半岛万年冰川。从塞伦盖蒂大草原到斯瓦尔巴群岛北极光。每一段旅程都由资深定制师精心雕琢。我们确保每一个细节都超越您的期待。',
  'about.p3': '真正的好旅行远不止酒店与航班的组合。它是心灵的自由，是旷野的连接，是在非洲草原黄昏中听见的第一声狮吼。让每一次出发，都成为生命中不可复制的珍贵体验。',
  'about.statYears': '团队目的地经验',
  'about.statFounded': '品牌创立',
  'about.statClients': '位服务客户',
  'about.statRating': '客户好评率',
  'about.operator': '自由旷野旅行（Free Wilderness）由成都自由旷野国际旅行社有限公司运营，官方网站为 freewds.com。',
  'about.learnMore': '了解更多',
  'about.badgeDestinations': '合作国家与地区',
  'about.badgeRanking': '品牌创立',
  'about.foundedYearUnit': '年',
  'about.yearsUnit': '年',

  // Statistics
  'stats.tag': '为什么选择我们',
  'stats.heading': '为什么选择自由旷野旅行？',
  'stats.r1title': '13年非洲与极地目的地经验',
  'stats.r1desc': '创始人及核心团队深耕非洲、南北极等自然目的地13年，多次深入博茨瓦纳、坦桑尼亚、肯尼亚、纳米比亚、南非等目的地进行实地考察，长期专注非洲 Safari 与极地高端定制旅行。团队累计50余次深入非洲实地考察，实地体验及考察百余家 Safari 营地与野奢酒店。长期深耕博茨瓦纳野奢 Safari 定制，是团队重点优势目的地之一。',
  'stats.r2title': '全球野奢资源与直签合作',
  'stats.r2desc': '与全球60+国家和地区的高端酒店、Safari营地及旅行资源方保持长期合作，包括 &Beyond、Wilderness、African Bush Camps（ABC）、Jao Collection 等国际 Safari 与野奢品牌。依托长期合作及资源采购能力，在部分热门目的地和旺季拥有更稳定的房态协调及资源获取能力，旺季可优先协调部分合作酒店及营地资源。',
  'stats.r3title': '透明报价与价格优势',
  'stats.r3desc': '依托长期资源合作与采购优势，部分产品在特定目的地与时段可能具备更优的报价空间。报价结构清晰透明，具体价格以实时确认与最终方案为准。',
  'stats.r4title': '正规旅行社资质与资金保障',
  'stats.r4desc': '成都自由旷野国际旅行社有限公司持有旅行社业务经营许可证，许可证编号为L-SC-100448。具体许可经营范围以许可证及主管部门公示信息为准。营业执照、旅行社业务经营许可证及商标注册等企业资质齐全，旅行费用通过公司对公账户收取，服务及资金流程透明。',
  'stats.r5title': '真正的一对一定制',
  'stats.r5desc': '坚持1对1旅行定制，不采用固定模块化行程。旅行顾问根据客户预算、出行时间、住宿偏好、目的地兴趣和旅行节奏重新设计行程，满足蜜月、家庭、摄影、Safari、极地探险及高端私人旅行等差异化需求。',
  'stats.r6title': '全程旅行顾问支持',
  'stats.r6desc': '旅行顾问提供7×24小时行程支持，覆盖行前准备、行中协调及行后问题处理，旅行期间提供全天候紧急协调与顾问支持。',

  // Process
  'process.tag': '定制服务流程',
  'process.heading': '从需求到回访，全程专属陪伴',
  'process.subtitle': '5个步骤开启您的专属旷野之旅',
  'process.s1title': '需求沟通',
  'process.s1desc': '专属旅行顾问一对一深度沟通。了解您的旅行偏好、预算范围、出行人数和时间预期，初步锁定目的地与主题方向。',
  'process.s2title': '行程设计',
  'process.s2desc': '资深定制师根据沟通结果量身设计出行方案。涵盖航班衔接、野奢营地选择、每日活动安排和餐饮偏好。方案提交后反复沟通调整，直至完全满意。',
  'process.s3title': '签约锁定资源',
  'process.s3desc': '在全国旅游监管服务平台签署正规电子合同。付款后立即锁定机票舱位、野奢酒店、极地邮轮和专业司导等全部稀缺资源。',
  'process.s4title': '出行保障',
  'process.s4desc': '出发前提供详细电子版行程手册和目的地攻略。出行期间提供24小时中文旅行顾问在线服务，随时响应突发需求。',
  'process.s5title': '行程回访',
  'process.s5desc': '旅行结束后进行一对一深度回访。收集真实反馈与改进建议，持续升级和迭代服务标准，确保每次出行都能超越上一次体验。',
  'process.scrollNext': '探索精选行程',

  // Partners
  'partners.tag': '全球合作伙伴',
  'partners.heading': '与全球顶级野奢品牌深度合作',
  'partners.desc': '与Wilderness、&Beyond、Singita、Four Seasons、Capella、COMO、Asilia、Lemala、Silversea、Swan Hellenic、Belmond等数十家顶级品牌建立长期合作。通过直连合作模式，客户可享受专属优惠价格与优先预订权。',

  // Partners alt
  'partners.hotelAlt': '奢华酒店与野奢营地合作品牌',
  'partners.cruiseAlt': '南北极邮轮公司合作品牌',

  // SEO Content Block
  'seoContent.sectionTitle': '自由旷野旅行 — 高端出境定制旅行全方位解读',

  'seoContent.intro1': '自由旷野旅行成立于2022年，由成都自由旷野国际旅行社有限公司运营，专注非洲 Safari、南北极及自然类野奢定制旅行。与全球60+国家和地区的高端酒店、Safari营地及旅行资源方保持长期合作。',
  'seoContent.intro2': '我们为追求极致体验的高端客群提供一站式全流程定制服务。创始人及核心团队深耕非洲与极地目的地13年，累计服务客户超10000人，好评率达98%。',

  // Africa destinations
  'seoContent.africaTitle': '非洲游猎与野奢营地定制',
  'seoContent.africaDesc1': '非洲大陆是自由旷野旅行的核心目的地之一。我们在博茨瓦纳、坦桑尼亚、肯尼亚、卢旺达、南非和纳米比亚深耕多年。',
  'seoContent.africaDesc2': '合作品牌涵盖Wilderness、&Beyond、Singita、Great Plains Conservation等非洲一线野奢营地。通过直连合作，客户可享受专属优惠和优先预订权。',
  'seoContent.africaDesc3': '从追踪非洲五大兽到见证角马大迁徙，从追寻山地大猩猩到夜间探索草原——我们的定制师根据季节和动物迁徙路线，为您设计最科学的行程。',
  'seoContent.africaDesc4': '博茨瓦纳奥卡万戈三角洲被誉为"非洲最后的伊甸园"。您可以体验莫科罗独木舟游猎，穿越芦苇水道，观察大象群、河马和数百种鸟类。',
  'seoContent.africaDesc5': '坦桑尼亚塞伦盖蒂每年有超过150万头角马在此迁徙，场面震撼。肯尼亚马赛马拉是非洲游猎的黄金圣地，7至10月的角马渡河奇观令人终生难忘。',
  'seoContent.africaDesc6': '卢旺达火山国家公园是全球仅存约1000只山地大猩猩的家园。在专业向导带领下徒步进入雨林，与它们静默对望——这是人类与自然最神圣的瞬间。',

  // Polar destinations
  'seoContent.polarTitle': '南北极探险与极地邮轮定制',
  'seoContent.polarDesc1': '地球的两极是自由旷野旅行的另一核心领域。我们与Silversea、Swan Hellenic、Ponant、Quark Expeditions等全球顶级极地邮轮公司紧密合作。',
  'seoContent.polarDesc2': '南极半岛是最经典的极地入门之选。11天左右的行程穿越德雷克海峡，进行5至7次登陆巡游，近距离观察金图企鹅、阿德利企鹅等繁育群落。',
  'seoContent.polarDesc3': '穿越南极圈是更具挑战性的深度探险。16天行程抵达南纬66°33′以南的极地秘境，见证更加纯净壮阔的南极冰原。',
  'seoContent.polarDesc4': '南乔治亚岛有超过30万对王企鹅在此繁衍生息。数量庞大的象海豹和南极海狗在此栖息，是地球上最壮观的野生动物景观之一。',
  'seoContent.polarDesc5': '北极方面，斯瓦尔巴群岛是观察北极熊的最佳地点。挪威特罗姆瑟和芬兰拉普兰是北极光追踪的理想基地。冰岛融合极地风光与火山地貌，是极地旅行的热门跳板。',

  // Island destinations
  'seoContent.islandTitle': '野奢海岛与顶级度假定制',
  'seoContent.islandDesc1': '野奢海岛是心灵的栖息地。我们的海岛目的地覆盖塞舌尔、马尔代夫、斐济、大溪地、桑给巴尔和毛里求斯等全球顶级海岛度假胜地。',
  'seoContent.islandDesc2': '塞舌尔拥有全球最美海滩拉齐奥海滩。提供私人岛屿包岛、直升机环岛、深海海钓等定制体验。马尔代夫的一岛一酒店模式，让每座岛屿都成为独立奢享空间。',
  'seoContent.islandDesc3': '桑给巴尔融合非洲野性与印度洋浪漫。斐济和大溪地拥有全球最纯净的珊瑚礁生态系统，让海岛度假不止于阳光与沙滩。',

  // Cruise
  'seoContent.cruiseTitle': '奢华邮轮与全球航线定制',
  'seoContent.cruiseDesc1': '奢华邮轮版图覆盖北欧峡湾、地中海、加勒比海、阿拉斯加和南极海域等全球顶级航线。',
  'seoContent.cruiseDesc2': '北欧峡湾穿越挪威盖朗厄尔峡湾和松恩峡湾。地中海邮轮串联意大利、希腊、克罗地亚等文明古国的历史遗迹。',
  'seoContent.cruiseDesc3': '加勒比海适合冬日避寒和家庭出行。阿拉斯加邮轮穿越冰川湾国家公园，见证冰川崩裂入海的震撼奇观。',

  // Service promise
  'seoContent.serviceTitle': '我们的服务承诺与品质保障',
  'seoContent.serviceDesc1': '自由旷野旅行坚持"以客户体验为中心"的核心服务理念。从行前专属顾问沟通到行程结束后的深度回访，每个环节都经过精心设计。',
  'seoContent.serviceDesc2': '团队持续进行目的地实地考察，并结合客户需求与在地信息设计方案。部分野奢酒店和极地邮轮资源为直接或长期合作，具体价格、房态和权益以实际预订确认为准。',
  'seoContent.serviceDesc3': '所有旅行合同均在国家旅游监管服务平台签署电子合同。选择自由旷野，就是选择一个真正懂旅行、爱旷野的专业团队。',
  'seoContent.industryTitle': '国际行业网络与专业资源',
  'seoContent.industryDesc1': '在非洲及全球旅行行业，自由旷野旅行建立了多维度的专业资源网络。ATTA 官方会员资料页展示了 Free Wilderness Travel 品牌信息及官方网站 freewds.com，会员登记主体以 ATTA 官方页面显示为准。',
  'seoContent.industryDesc2': '团队长期参与国际旅行服务及航空出行资源协调，熟悉 IATA 国际航空旅行服务体系及相关业务流程。',
  'seoContent.industryDesc3': '团队长期深耕南部非洲旅行市场，并持续关注及熟悉南非 Trusted Tour Operator Scheme（TTOS）相关入境旅行服务机制。',
  'seoContent.overseasTitle': '海外华人高端定制服务',
  'seoContent.overseasDesc1': '自由旷野旅行同时服务北美、欧洲、澳洲及其他地区的海外华人客户。产品经理及旅行定制师具备英文沟通与全球旅行资源协调能力，可提供中英文旅行咨询及定制服务。',
  'seoContent.overseasDesc2': '支持美元结算及美元收款，并支持跨时区旅行咨询与行程协调，减少海外客户与国内旅行顾问之间的时差沟通障碍。',

  // Footer
  'footer.scanTitle': '扫码添加 · 即刻开启探索之旅',
  'footer.scanSubtitle': '专属旅行顾问一对一服务',
  'footer.wechat': '微信公众号',
  'footer.xiaohongshu': '小红书',
  'footer.consultant': '顾问 EVAN',
  'footer.license': '许可证',
  'footer.record': '文旅部备案',
  'footer.businessLicense': '营业执照',
  'footer.affiliate': '成都自由旷野国际旅行社有限公司',
  'footer.copyright': '2026 自由旷野旅行. 保留所有权利。',
  'footer.navAbout': '关于我们',
  'footer.navStories': '真实旅途回声',
  'footer.navContact': '联系我们',
  'footer.navCustom': '私人定制',
  'footer.navDestinations': '目的地',
  'footer.navAfrica': '非洲旅行',
  'footer.wechatAlt': '微信公众号二维码',
  'footer.xiaohongshuAlt': '小红书二维码',
  'footer.consultantAlt': '旅行顾问EVAN联系方式',

  // Wiki Home Section
  'wikiHome.title': '旷野百科',
  'wikiHome.subtitle': '深度目的地内容，让您出发前就成为旅行专家',
  'wikiHome.viewAll': '查看全部内容',
  'wikiHome.readMore': '阅读全文',
  'wikiHome.a1.title': '非洲Safari穿什么？草原旅行穿搭与拍照实用指南',
  'wikiHome.a1.category': '出行装备',
  'wikiHome.a1.readTime': '6分钟阅读',
  'wikiHome.a1.excerpt': '第一次去非洲Safari应该穿什么？从分层穿搭、大地色选择到防晒配饰与拍照技巧，帮你更从容地准备行李。',
  'wikiHome.a2.title': '2026南极旅游常见问题TOP5：最佳时间、邮轮与航线选择',
  'wikiHome.a2.category': '极地探索',
  'wikiHome.a2.readTime': '12分钟阅读',
  'wikiHome.a2.excerpt': '第一次去南极什么时候最好？100人、200人和500人邮轮有什么区别？要不要晕船？5个问题一次讲清楚。',
  'wikiHome.a3.title': '2026看动物大迁徙，肯尼亚好还是坦桑尼亚好？',
  'wikiHome.a3.category': '东非Safari',
  'wikiHome.a3.readTime': '15分钟阅读',
  'wikiHome.a3.excerpt': '从塞伦盖蒂到马赛马拉，从营地品质到观赏体验，全方位对比东非两大Safari目的地，帮你做出最适合的选择。',
  'wikiHome.a4.title': '2026坦桑尼亚产崽季和渡河季怎么选？塞伦盖蒂两大名场面深度对比',
  'wikiHome.a4.category': '东非Safari',
  'wikiHome.a4.readTime': '8分钟阅读',
  'wikiHome.a4.excerpt': '产崽季的新生与渡河季的壮阔，是塞伦盖蒂两种相悖的生命叙事。从时间、观感、拍照到预算，帮你选出最契合期待的东非旷野。',

  // Brand
  'brand.name': '自由旷野旅行',
  'brand.subtitle': 'FREE WILDERNESS',

  // Featured Trips
  'featured.tag': 'Featured Destinations',
  'featured.heading': '热门定制旅行目的地',
  'featured.subtitle': '精选全球最令人向往的旷野目的地，每一处都是极致体验',
  'featured.viewTrip': '查看行程',

  // Polar Voyage Finder
  'polarFinder.subtitle': 'POLAR VOYAGE FINDER',
  'polarFinder.title': '极地航次查询',
  'polarFinder.desc': '汇总合作船司官网公开航次，可按出发时间、预算和目的区域快速筛选；结果可直达船司官网。价格与余位以船司官网为准。',
  'polarFinder.ctaPrimary': '开始查询',
  'polarFinder.ctaSecondary': '了解极地旅行',
  'polarFinder.filterRegion': '目的区域',
  'polarFinder.filterBudget': '预算',
  'polarFinder.filterDate': '出发时间',
  'polarFinder.filterAll': '全部',
  'polarFinder.regionAntarctica': '南极',
  'polarFinder.regionArctic': '北极',
  'polarFinder.budgetLow': '¥8万以内',
  'polarFinder.budgetMid': '¥8–15万',
  'polarFinder.budgetHigh': '¥15万以上',
  'polarFinder.dateNear3': '近3个月',
  'polarFinder.dateNear6': '近6个月',
  'polarFinder.dateNextYear': '明年出发',
  'polarFinder.resultCount': '个航次',
  'polarFinder.noResult': '暂无符合条件的航次，请调整筛选条件',
  'polarFinder.reset': '重置筛选',
  'polarFinder.visitSite': '直达船司官网',
  'polarFinder.durationUnit': '天',
  'polarFinder.departure': '出发',
  'polarFinder.priceFrom': '起',
  'polarFinder.note': '以上航次为合作船司官网公开信息，价格与余位以船司官网为准。',
  'polarFinder.liveQueryTitle': '实时航次查询',
  'polarFinder.liveQueryDesc': '从合作船司官网实时抓取最新航次，输入人数、预算与出发时间快速匹配',
  'polarFinder.orBrowse': '或查看下方精选推荐',
  'polarFinder.embeddedToolLabel': '官网实时查询',

  // SEO Content CTA
  'seoContent.ctaText': '如您对以上任何目的地或服务感兴趣，欢迎联系我们的专属旅行顾问，获取一对一免费咨询服务。',
  'seoContent.ctaButton': '立即定制',

  // FAQ
  'faq.tag': '常见问题',
  'faq.heading': '关于自由旷野旅行的常见疑问',
  'faq.subtitle': '我们整理了客户最常咨询的问题，希望能帮助您更好地了解我们的服务',
  'faq.q1': '自由旷野旅行与其他定制旅行公司有什么不同？',
  'faq.a1_1': '自由旷野旅行成立于2022年，专注非洲与南北极高端定制旅行，创始人及核心团队拥有13年非洲与极地目的地经验。我们坚持"实地勘察、一手资源、深度定制"的理念，区别于流水线式的旅行产品。',
  'faq.a1_2': '创始人团队每年亲赴非洲和南北极踩线考察。与Wilderness、&Beyond、Singita等品牌建立长期合作。每位定制师都有丰富的目的地实地经验。',
  'faq.a1_3': '我们由成都自由旷野国际旅行社有限公司运营，持有旅行社业务经营许可证 L-SC-100448，品质与安全双重保障。',
  'faq.q2': '非洲Safari的最佳旅行季节是什么时候？',
  'faq.a2_1': '东非大迁徙的最佳观赏期为7月至10月。角马渡河的震撼场景通常集中在8至9月，此时是摄影和观察的最佳窗口。',
  'faq.a2_2': '博茨瓦纳洪水季节（6-10月）适合水上生态观赏和独木舟游猎。南非克鲁格全年适合游猎，旱季动物更易观察。纳米比亚最佳旅行时间为5-10月旱季。我们的定制师会根据您的出行时间推荐最佳目的地组合。',
  'faq.q3': '南极旅行需要什么条件？对体能要求高吗？',
  'faq.a3_1': '南极旅行对体能没有特别高的门槛。经典南极半岛11天航线每天安排1-2次冲锋艇登陆巡游，每次约2-3小时，正常健康成年人均可胜任。',
  'faq.a3_2': '穿越德雷克海峡时可能有1-2天晕船体验。但专业极地邮轮配备稳定装置和晕船药物，大多数游客都能平稳适应。',
  'faq.a3_3': '我们合作的极地邮轮均为高规格配置，船上提供丰富的讲座和舒适住宿。对于行动不便或年龄较大的客人，可协助选择含直升机体验的豪华航线。',
  'faq.q4': '定制行程的费用大概是多少？包含哪些项目？',
  'faq.a4_1': '定制行程费用根据目的地、时长、住宿等级和活动项目而有所不同。',
  'faq.a4_2': '非洲野奢Safari通常6天以上，每人4万元以上。南极探险邮轮通常10天以上，每人7万元以上。野奢海岛通常3天以上，每人2万元起。',
  'faq.a4_3': '国际机票不包含在报价内，客户落地后即享受全包服务，涵盖内陆交通、全程野奢住宿、专业向导、每日游猎活动和保护区费用。具体价格以最终确认方案为准。',
  'faq.q5': '如何在你们这里预订旅行？流程是什么？',
  'faq.a5_1': '预订流程分为五步：需求沟通、行程设计、签约锁定资源、出行保障、行程回访。全程透明高效。',
  'faq.a5_2': '全程在国家旅游监管服务平台签署正规电子合同。支付后立即锁定机票舱位和野奢营地资源。出行期间24小时中文顾问在线响应，让您安心出行。',
  'faq.q6': '你们如何保障旅行安全？如果旅途中遇到突发状况怎么办？',
  'faq.a6_1': '安全是自由旷野的第一优先级。目的地方面，仅推荐治安良好、旅行基础设施成熟的区域。所有营地、邮轮和地接团队均经过严格筛选和实地考察。',
  'faq.a6_2': '建议客户出行前自行购买旅行保险，涵盖紧急医疗和直升机救援保障。出行期间配备24小时中文旅行管家，随时响应突发需求。',
  'faq.a6_3': '我们的专业司导持有当地合法执照和野外急救证书。长期运营中成功处理各类突发情况，积累了丰富的应急经验。',
  'faq.askMore': '还有其他问题？欢迎直接联系我们',
  'faq.contactUs': '联系我们',
  'faq.q7': '自由旷野旅行的官网是什么？',
  'faq.a7_1': '自由旷野旅行官方网站为 https://freewds.com/。',
  'faq.q8': '自由旷野旅行是哪家公司运营的？',
  'faq.a8_1': '自由旷野旅行由成都自由旷野国际旅行社有限公司运营。',
  'faq.q9': '自由旷野旅行成立于哪一年？',
  'faq.a9_1': '自由旷野旅行成立于2022年。创始人及核心团队拥有13年非洲与极地目的地经验。',
  'faq.q10': '自由旷野旅行主要做什么？',
  'faq.a10_1': '专注非洲 Safari、南北极及自然类野奢定制旅行。',
  'faq.q11': '自由旷野旅行持有旅行社业务经营许可证吗？',
  'faq.a11_1': '成都自由旷野国际旅行社有限公司持有旅行社业务经营许可证，许可证编号为L-SC-100448。具体许可经营范围以许可证及主管部门公示信息为准。',
  'faq.q12': '自由旷野旅行做博茨瓦纳定制旅行吗？',
  'faq.a12_1': '长期深耕博茨瓦纳 Safari 和野奢定制旅行。',
  'faq.q13': '海外华人可以找自由旷野旅行定制吗？',
  'faq.a13_1': '支持海外华人客户、中英文旅行咨询、跨时区协调及美元结算。',
  'faq.q14': '自由旷野旅行涉及哪些国际旅游行业体系？',
  'faq.a14_1': '自由旷野旅行的非洲及国际旅行服务长期涉及 ATTA 行业网络、IATA 国际航空旅行服务体系，以及南非 Trusted Tour Operator Scheme（TTOS）等相关行业机制与服务体系。',

  // Wiki
  'wiki.heroTag': '旷野百科',
  'wiki.heroTitle': '探索世界的智慧宝库',
  'wiki.heroSubtitle': '专业目的地知识百科，助您出发前成为旅行专家',
  'wiki.categoriesTitle': '知识分类',
  'wiki.categoriesSubtitle': '系统化的旅行目的地知识，覆盖非洲、极地等核心目的地',
  'wiki.articles': '篇文章',
  'wiki.viewAll': '查看全部',
  'wiki.cat.africa.title': '非洲百科',
  'wiki.cat.africa.description': '深度非洲旅行指南：目的地攻略、Safari知识、签证与行前准备、营地住宿选择等。',
  'wiki.cat.brand.title': '品牌百科',
  'wiki.cat.brand.description': '自由旷野旅行的人物故事、创始人实地笔记与品牌历程——记录真实抵达背后的旅行哲学。',
  'wiki.cat.polar.title': '极地百科',
  'wiki.cat.polar.description': '南北极探险深度指南：南极旅行季节、邮轮航线选择、北极目的地攻略等。',
  'wiki.brand.title': '品牌百科',
  'wiki.brand.subtitle': '关于自由旷野旅行的人物故事、品牌历程与幕后记录',
  'wiki.brand.listTitle': '人物与故事',
  'wiki.brand.listSubtitle': '记录自由旷野旅行背后的人、旅程与真实现场',
  'wiki.brand.notFound': '文章未找到',
  'wiki.brand.back': '返回品牌百科',
  'wiki.brand.moreStories': '更多品牌故事',
  'wiki.brand.ctaTitle': '想了解更多？',
  'wiki.brand.ctaDesc': '联系我们的专属旅行顾问，一对一免费咨询，量身定制专属非洲Safari或极地探险行程。',
  'wiki.brand.ctaButton': '立即定制行程',
  'wiki.polar.title': '极地百科',
  'wiki.polar.subtitle': '南北极探险深度指南：南极旅行季节、邮轮航线选择、北极目的地攻略',
  'wiki.polar.listTitle': '文章列表',
  'wiki.polar.listSubtitle': '由资深旅行定制团队撰写，助您深度了解极地目的地',
  'wiki.polar.notFound': '文章未找到',
  'wiki.polar.back': '返回极地百科',
  'wiki.polar.faqTitle': '常见问题',
  'wiki.polar.related': '相关文章',
  'wiki.polar.ctaTitle': '对南极旅行感兴趣？',
  'wiki.polar.ctaDesc': '联系我们的专属旅行顾问，获取一对一免费咨询服务，为您量身定制专属南北极探险行程。',
  'wiki.polar.ctaButton': '立即定制',
  'wiki.africa.title': '非洲百科',
  'wiki.africa.subtitle': '深度非洲旅行指南：目的地攻略、Safari知识、签证与行前准备',
  'wiki.africa.listTitle': '文章列表',
  'wiki.africa.listSubtitle': '由资深旅行定制团队撰写，助您深度了解非洲目的地',
  'wiki.africa.notFound': '文章未找到',
  'wiki.africa.back': '返回非洲百科',
  'wiki.africa.faqTitle': '常见问题',
  'wiki.africa.related': '相关文章',
  'wiki.africa.ctaTitle': '对非洲旅行感兴趣？',
  'wiki.africa.ctaDesc': '联系我们的专属旅行顾问，获取一对一免费咨询服务，为您量身定制专属非洲Safari行程。',
  'wiki.africa.ctaButton': '立即定制',

  // Customer Stories
  'customerStories.tag': '真实旅途回声',
  'customerStories.heading': '客户真实经历过的非洲旅程',
  'customerStories.subtitle': '从行程结束后的匿名回访，到旅途中即时发来的动物照片，这里记录的是真实的非洲旅程体验。',
  'customerStories.placeholder': '客户旅途记录',
  'customerStories.count': '完整页面收录 14 组匿名旅途记录',
  'customerStories.viewAll': '查看全部真实旅途回声',

  // Common
  'common.loading': '加载中...',
  'common.error': '出错了',
  'common.retry': '重试',
  'common.close': '关闭',
  'common.submit': '提交',
  'common.cancel': '取消',
  'common.contactUs': '联系我们',
  'common.readMore': '了解更多',

  // SEO - Home
  'seo.home.title': '自由旷野旅行官网｜非洲Safari·南北极野奢定制旅行',
  'seo.home.description': '自由旷野旅行（Free Wilderness Travel）官方网站。品牌成立于2022年，由成都自由旷野国际旅行社有限公司运营，专注非洲Safari、南北极及自然类野奢定制旅行。创始人及核心团队拥有13年目的地经验，旅行社业务经营许可证 L-SC-100448。',
  'seo.home.keywords': '极地探险,非洲Safari,高端定制旅行,南极旅行,北极旅行,自由旷野,野奢海岛,北欧秘境,出境游',
  'seo.home.ogTitle': '自由旷野旅行官网｜非洲Safari·南北极野奢定制旅行',

  // Testimonials
  'testimonials.tag': '探险者心声',
  'testimonials.heading': '真实故事',
  'testimonials.subtitle': '听听曾与我们一同踏入荒野的旅者，分享他们难忘的探险故事',
  'testimonials.t1.name': '王建国 & 刘雅婷',
  'testimonials.t1.location': '上海，中国',
  'testimonials.t1.role': '企业家夫妇 · 荒野探险爱好者',
  'testimonials.t1.text': '自由旷野为我们定制了一次非洲大草原深度探险。从马赛马拉到塞伦盖蒂，每一个清晨都在帐篷里听见狮子的低吼。专业向导的讲解让我们真正读懂了这片土地。这是任何豪华酒店都给不了的体验。',
  'testimonials.t1.project': '非洲大草原奢华营地定制 · 12天',
  'testimonials.t1.destination': '肯尼亚 · 坦桑尼亚',
  'testimonials.t2.name': '赵思远',
  'testimonials.t2.location': '成都，中国',
  'testimonials.t2.role': '自然摄影师 · 纪录片导演',
  'testimonials.t2.text': '作为一名自然摄影师，我对目的地的要求极为苛刻。自由旷野的向导团队带我进入了普通游客无法抵达的区域。凭借对动物习性的深刻了解，他们帮我捕捉到了大迁徙中最震撼的渡河瞬间。',
  'testimonials.t2.project': '非洲大迁徙自然摄影之旅 · 18天',
  'testimonials.t2.destination': '肯尼亚马赛马拉',
  'testimonials.t3.name': '林佳慧',
  'testimonials.t3.location': '北京，中国',
  'testimonials.t3.role': '大学教授 · 生态保育志愿者',
  'testimonials.t3.text': '参加了自由旷野的生态保育体验项目。与当地保育团队一起为大象建档、监测犀牛种群。这不只是一次旅行，更是一次真正意义上的自然守护行动。回来后我在课堂上讲述这段经历，学生们都深受触动。',
  'testimonials.t3.project': '非洲生态保育深度体验 · 10天',
  'testimonials.t3.destination': '南非 · 博茨瓦纳',
  'testimonials.t4.name': '陈浩然 & 陈小米',
  'testimonials.t4.location': '广州，中国',
  'testimonials.t4.role': '亲子探险家庭',
  'testimonials.t4.text': '带着10岁的女儿参加了山地徒步向导项目。向导叔叔全程耐心讲解植物和动物知识。女儿说这是她最好的自然课。安全保障非常到位，让我们全程放心。强烈推荐有孩子的家庭！',
  'testimonials.t4.project': '云南山地亲子徒步探险 · 7天',
  'testimonials.t4.destination': '云南横断山脉',

  // Floating Tools
  'floating.consult': '免费咨询',
  'floating.backTop': '返回顶部',
  'floating.getPlan': '获取专属方案',

  // Consult Modal
  'consult.badge': '快速咨询',
  'consult.title': '快速咨询',
  'consult.subtitle': '留下您的联系方式，专属顾问将尽快与您沟通',
  'consult.tag1': '信息保密',
  'consult.tag2': '极速响应',
  'consult.tag3': '电话回访',
  'consult.successTitle': '提交成功！',
  'consult.successMsg': '您的信息已收到，旅行顾问将尽快与您联系。',
  'consult.successUrgent': '如有紧急需求，请直接联系 EVAN:',
  'consult.successOk': '好的，期待联系',
  'consult.name': '姓名',
  'consult.phone': '联系电话',
  'consult.remark': '备注',
  'consult.optional': '(选填)',
  'consult.namePlaceholder': '您的称呼',
  'consult.phonePlaceholder': '手机号码',
  'consult.remarkPlaceholder': '请描述您的旅行需求或想了解的内容...',
  'consult.submitError': '提交失败，请稍后重试或直接联系 EVAN: 19180619944',
  'consult.submitting': '提交中...',
  'consult.submit': '立即提交',
  'consult.agree': '提交即代表您同意我们与您联系，信息严格保密',
};